import React from "react";
import styled from "styled-components";
import { rem } from "polished";
import { ReactComponent as CloseIcon } from "../../assets/img/close-icon.svg";

const El = styled.button`
  appearance: none;
  width: ${rem(33)};
  height: ${rem(33)};
  right: ${rem(15)};
  top: ${rem(15)};
  position: absolute;
  background: #f3f4f6;
  border: 0;
  border-radius: 999em;
  cursor: pointer;
  padding: 0;
  display: flex;
  z-index: 2;

  svg {
    fill: #858686;
    align-self: center;
    margin: 0 auto;
    transition: fill 0.3s;
  }

  &:hover {
    svg {
      fill: #CC6F4C;
    }
  }
`;

const CloseButton = ({ closeModal }) => (
  <El onClick={closeModal}>
    <CloseIcon />
  </El>
);

export default CloseButton;
